// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const barbaracle: PokeData = {
  "id": 689,
  "name": "barbaracle",
  "height": 13,
  "weight": 960,
  "base_experience": 175,
  "types": [
    PokeType.ROCK,
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "sand-attack",
    "water-gun",
    "withdraw",
    "clamp",
    "skull-bash",
    "fury-swipes",
    "slash",
    "mud-slap",
    "fury-cutter",
    "cross-chop",
    "ancient-power",
    "rock-polish",
    "night-slash",
    "stone-edge",
    "hone-claws",
    "shell-smash",
    "razor-shell"
  ],
  "moves": [
    "scratch",
    "mud-slap",
    "cross-chop",
    "ancient-power",
    "night-slash",
    "rain-dance",
    "rock-slide",
    "water-spout",
    "rock-blast",
    "life-dew",
    "rock-throw",
    "boulder_bash",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 353,
    "item": null,
    "species": [
      {
        "name": "binacle",
        "order": 689,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "barbaracle",
        "order": 690,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": 688,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 105,
    "ability_power": 162
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
